// removed by extract-text-webpack-plugin
module.exports = {"appElement":"_3Hcp44gYEA50f_kTznIWys","icon":"_3_M-21lvtrKKTuZPPX_LJJ","selected":"QQb-kUOgclad-B_NHRL6L","appName":"eIRPTnlR67BhfdS3ah4WU"};


//////////////////
// WEBPACK FOOTER
// ./src/components/appList/AppElement.css
// module id = 469
// module chunks = 0